<template>
  <div class="wrap" v-if="!isLoading && likeList.length !== 0">
    <ul v-if="viewMode !== 'live'" class="my-like-list">
      <li v-for="(likeItem, index) in likeList" :key="index">
        <div>
            <span @click.prevent="moveUrl(likeItem)" class="con-img thumb-image">
<!--                <img :src="likeItem.image | addPostfixAndUrl('270')" alt=""/>-->
                <img v-lazy="getLazyLoadObj(likeItem)" :alt="likeItem.programtitle"/>
                <age-limits :targetAge="+likeItem.targetage" :contentType="viewMode"/>
                <div :class="adultDimClass(likeItem)"></div>
            </span>
            <!-- 좋아요 프로그램 -->
            <span class="my-like-check" v-if="viewMode === 'program'">
                <btn-zzim-with-api :isOn="likeItem.zzim" :contentsType="viewMode" :contentsId="likeItem.programid" :index="index" :is-mypooq="true"/>
            </span>
            <!-- 좋아요 영화 -->
            <span class="my-like-check" v-if="viewMode === 'movie'">
                <btn-zzim-with-api :isOn="likeItem.zzim" :contentsType="viewMode" :contentsId="likeItem.movieid" :index="index" :is-mypooq="true"/>
            </span>
            <span  @click.prevent="moveUrl(likeItem)" class="con-text-wrap">
              <template v-if="viewMode === 'movie'">
                <strong class="con-tit" v-if="likeItem.title">{{likeItem.title}}</strong>
                <span class="con-text01"> {{likeItem.genrename}} <span class="title-dot"></span> {{Math.round(likeItem.playtime / 60)}}분 </span>
              </template>
              <template v-else>
                <strong class="con-tit" v-if="likeItem.programtitle">{{likeItem.programtitle}}</strong>
                <strong class="con-tit" v-if="likeItem.title">{{likeItem.title}}</strong>
                <span class="con-text01" v-if="likeItem.channelname">{{likeItem.channelname}}</span>
              </template>
            </span>
        </div>
      </li>
    </ul>
    <ul v-else class="my-like-list02">
      <li v-for="(channelItem, index) in likeList" :key="index">
        <a @click.prevent="moveUrl(channelItem)" href="#">
          <span class="con-img"><img :src="channelItem.image | addPostfixAndUrl('180')" alt=""></span>
          <span class="con-text-wrap">
            <strong class="con-tit">{{ channelItem.channelname }}</strong>
          </span>
        </a>
        <span class="my-like-check">
          <btn-zzim-with-api :isOn="channelItem.zzim" :contentsType="viewMode" :contentsId="channelItem.channelid" :index="index" :is-mypooq="true"/>
        </span>
      </li>
    </ul>
    <paging-component :current-page="currentPage" :page-count="totalCount" :limit="limit" :paging-count="pagingCnt" wrapper-class="paging-type02"/>
  </div>

  <div class="wrap" v-else-if="!isLoading && likeList.length === 0">
    <empty-list :text="emptyText"></empty-list>
  </div>
</template>

<script>
import AgeLimits from '@/components/model/AgeLimits'
import PagingComponent from '@/components/common/PagingComponent'
import { getZzimContents } from '@/common/utils/request'
import { addPostfixAndUrl, scrollTop } from '@/common/utils/common'
import EmptyList from '@/components/mypooq/EmptyList'
import _ from 'lodash'
import { resizeThumbnail } from '@/common/utils/image'
import cookie from '@/common/utils/cookie'
import BtnZzimWithApi from '@/components/button/BtnZzimWithApi'
import { PATH_NAME_PLAYER_LIVE, PATH_NAME_PLAYER_MOVIE, PATH_NAME_PLAYER_VOD } from '@/common/resources/router.const'

export default {
  components: {
    BtnZzimWithApi,
    AgeLimits,
    PagingComponent,
    EmptyList
  },
  filters: {
    addPostfixAndUrl
  },
  props: {
    viewMode: {
      type: String
    },
    showRecommend: {
      type: Function
    }
  },
  data () {
    return {
      likeList: [],
      type: '',
      currentPage: 1,
      pagingCnt: 10,
      limit: 30,
      pageCount: 0,
      emptyText: '',
      totalCount: 0,
      isLoading: true,
      routeName: '',
      placeholderImage: require('../../assets/images/common/img_default_thum_1.png')
    }
  },
  methods: {
    url (url) {
      return location.protocol + '//' + url
    },
    moveUrl (item) {
      if (this.viewMode === 'program') {
        this.$router.push({
          name: PATH_NAME_PLAYER_VOD,
          query: {
            programid: item.programid
          }
        })
      } else if (this.viewMode === 'movie') {
        this.$router.push({
          name: PATH_NAME_PLAYER_MOVIE,
          query: {
            movieid: item.movieid
          }
        })
      } else {
        this.$router.push({
          name: PATH_NAME_PLAYER_LIVE,
          query: {
            channelid: item.channelid
          }
        })
      }
    },
    setData () {
      this.isLoading = true
      scrollTop()
      this.currentPage = Number(_.get(this.$route, ['query', 'page'], '1'))
      let offset = this.limit * (this.currentPage - 1)
      getZzimContents({ contenttype: this.viewMode, offset, limit: this.limit }).then(({ data }) => {
        switch (this.viewMode) {
          case 'program':
            this.type = 'programlist'
            this.emptyText = '구독한 프로그램 내역이 없어요.'
            this.routeName = 'like_program'
            break
          case 'movie':
            this.type = 'movielist'
            this.emptyText = '찜한 영화 내역이 없어요.'
            this.routeName = 'like_movie'
            break
          default:
            this.type = 'livelist'
            this.emptyText = '좋아요한 채널 내역이 없어요.'
            this.routeName = 'like_channel'
        }
        console.log(data)
        data.forEach((item) => {
          if (item.type === this.type) {
            this.likeList = item.list
            if (offset === 0 && this.likeList.length === 0 && this.type !== 'movielist') {
              this.showRecommend()
            }
          }
          this.isLoading = false
        })
        if (this.likeList.length === 0 && offset !== 0 && this.currentPage !== 1) {
          this.$router.push({
            name: this.routeName,
            query: {
              page: this.currentPage - 1
            }
          })
        }
        this.totalCount = Number(_.get(data, ['0', 'pagecount'], '0'))
      })
    },
    getLazyLoadObj (movieItem) {
      return {
        src: resizeThumbnail(movieItem.image, { width: 240, height: 346, isSquare: false }),
        error: this.placeholderImage,
        loading: this.placeholderImage
      }
    },
    adultDimClass (item) {
      const targetage = _.get(item, 'targetage', 0)
      const isDim = cookie.isNotVerifiedAdultUser() && targetage >= 21
      if (isDim) {
        return this.viewMode === 'movie' ? 'movie-lock-21' : 'vod-lock-21'
      } else {
        return ''
      }
    }
  },
  created () {
    console.log(this.likeList)
    this.setData()
  }
}
</script>

<style lang="css">
.vod-top-right{
  position: absolute;
  top: 7px;
  right: 7px;
  z-index: 800;
}
</style>
